import { useState } from 'react';
import TranslationPageLayout from '../../Components/shared/TranslationPageLayout.js';
import CommonImage from '../../Components/shared/ImageComponent';
// import Footer from '../../Components/shared/Footer';
import { financialDocumentTranslationData } from '../../Components/shared/faqList';
import FAQ from '../../Components/shared/FAQ';
// import Navbar from '../../Components/shared/Header';
import { IMAGES } from "./imagesImports.js"
import {
    section2Images,
    section3Images,
    section5Images,
    section6Images,
} from "./imagesItem.js"
import { useHorizontalScroll } from "../../Hooks/useHorizontalScroll.js";
import HorizontleButtons from '../../Components/shared/HorizontleButtons.js';
import "./index.css"
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount';
import { useLocation } from 'react-router-dom';
import Navbar from '../HomePage/header.js';
import Footer from '../HomePage/footer.js';

const FinancialDocumentTranslationPage = ({ windowSize }) => {
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
    const {
        scrollRef: section6Ref,
        scrollLeft: section6Left,
        scrollRight: section6Right,
    } = useHorizontalScroll(250);

    // Hook for section 2
    const {
        scrollRef: section2Ref,
        scrollLeft: section2Left,
        scrollRight: section2Right,
    } = useHorizontalScroll(250);

    const handleLoginOpen = (newState) => {
        setIsModalOpen(newState);
    };

    const handleCreateAccountOpen = (newState) => {
        setIsCreateAccountOpen(newState);
    };

    return (
        <TranslationPageLayout>

            <SignInForm
                open={isModalOpen}
                isLoginFormOpen={handleLoginOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
            />
            <CreateAccount
                open={isCreateAccountOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
                isLoginFormOpen={handleLoginOpen}
            />

            {/* Financial Hero Section */}
            <div role='financial Hero Section' className='w-full'>
                <div className='financial-HeroSection'>
                    <Navbar
                        windowSize={windowSize}
                        isLoginFormOpen={handleLoginOpen}
                    />
                    <div role='content-section' className='financial-HeroSectionContent'>
                        <div className='financial-contentTitle'>
                            <div className='financial-contentTitleLarge'>Best <span>Financial</span> Translation by <span>eVerbary</span> </div>
                            <div className='financial-contentTitleSmall'>eVerbary delivers financial document translation services designed to meet the strict standards of global finance. <br /> We provide certified translation service options for institutions, firms, and professionals who need high-quality, accurate translations of financial documents.</div>
                        </div>
                        <div className='financial-contentSection2'>
                            <div className='flex flex-col items-center gap-4'>
                                <p className='financial-contentSection2Text'>Our professional translators handle everything from financial statements and balance sheets to audit reports and investor communications.</p>
                                <p className='financial-contentSection2TextSmall'>Whether you're submitting to a regulatory body, working on a cross-border transaction, or providing multilingual financial content to stakeholders, we translate financial documents with precision.</p>
                            </div>
                            <img className='md:inline-block hidden' width={398} height={280} src={require('../../assets/fin-hero-img.png')} />
                            <img className='md:hidden inline-block' width={398} height={280} src={require('../../assets/fin-hero-imgMobile.png')} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Why Choose eVerbary’s Financial Translation Services */}
            <div className='financial-section2'>
                <div role='section2-header' className='financial-section2Header'>
                    <div className='financial-section2HeaderHeading'>Why Choose <br /> eVerbary’s Financial Translation Services</div>
                    <div className='financial-section2HeaderText'>Financial documents often contain complex terminology and sensitive information. Mistakes in translation can create legal issues, compliance risks, or misinterpretations. That’s why we assign every translation project to expert financial translators who understand the language of finance.</div>
                </div>
                <div ref={section2Ref} role='section2-Images' className='financial-section2Images scrollbar-hide'>
                    {section2Images?.map((item, idx) => (
                        <div key={idx} className='financial-section2Image'>
                            <CommonImage src={item?.src} alt={item?.alt} width={49} height={49} />
                            <div className='financial-imageBottomText'>{item?.text}</div>
                        </div>
                    ))}
                </div>
                <HorizontleButtons
                    scrollLeft={section2Left}
                    scrollRight={section2Right}
                />
                <span role='section2-bottom-text' className='financial-section2HBottomText'>We’re the translation service provider that financial institutions and accounting firms trust to deliver consistent, high-quality work.</span>
            </div>

            {/* Types of Financial Documents We Translate */}
            <div className="financial-section3">
                <div className="financial-section3Content">
                    <div className="sm:block hidden financial-section3ContentHeading">Types of Financial Documents <br /> We Translate</div>
                    <div className="sm:hidden block financial-section3ContentHeading">Most Popular Documents</div>
                    <div className="sm:block hidden financial-section3ContentText">eVerbary supports an array of financial and business documents,</div>
                    <div className="sm:hidden block text-center financial-section3ContentText">The most popular documents for translation. Get your standard or certified translations quickly and accurately.</div>
                </div>

                <img className='financial-section3-desktopImg' src={IMAGES.FIN_SEC3_DESKTOPIMG} alt="section_3_image" />
                <img className='financial-section3-mobileImg' src={IMAGES.FIN_SEC3_MOBILEIMG} alt="section_3_image" />
            </div>

            {/* Our Translation Process for Financial Documents */}
            <div role='finanical-page-section-4' className='immigration-section5'>
                <div role='section3-header' className='immigration-section5Header'>
                    <span className='immigration-section5HeaderHeading'>Our Translation Process for Financial Documents</span>
                    <span className='immigration-section5HeaderText'>Our translation process ensures every financial document translation is accurate and compliant:</span>
                </div>
                <div role='section6-Images-and-text' className='immigration-section5ImagesAndText'>
                    <div role="section6-Images" className="immigration-section5Images">
                        {section3Images?.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    // backgroundImage: `url(${windowSize.width < 640 && item.mobileSrc})`,
                                    maxWidth: windowSize.width < 640 ? '100%' : '248px',
                                    minHeight: windowSize.width < 640 ? '246px' : '372px',
                                    background : `${item?.backgroundColor}`

                                }}
                                className='immigration-section5ImageItem relative'

                            >
                                <img className='rounded-4xl sm:w-auto w-[200px]' src={item?.src} />
                                <div className='flex flex-col self-start mr-4 gap-1 absolute bottom-6'>
                                    <span className='imm-sec5-heading'>{item?.heading}</span>
                                    <span className='imm-sec5-desc'>{item?.description}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <span role='section6-Images-text' className='immigration-section5BottomText'>This process is guided by our commitment to translation quality, confidentiality, and accuracy.</span>
                </div>
            </div>

            <div className='financial-section5'>
                {section5Images?.map((item, index) => (
                    <div
                        key={index}
                        style={{ backgroundImage: `url(${item?.src})` }}
                        className='financial-section5-container'
                    >
                        <span dangerouslySetInnerHTML={{ __html: item?.heading }} />
                        <span dangerouslySetInnerHTML={{ __html: item?.text }} />
                    </div>
                ))}
            </div>

            {/* Financial Services Translation with Global Reach*/}
            <div className='financial-section6-container'>
                <div className='financial-section6'>
                    <div role='section6-header' className='financial-section6Header'>
                        <div className='financial-section6HeaderHeading'>Financial Services Translation with Global Reach</div>
                        <div className='financial-section6HeaderText'>Financial translation is more than changing language, it requires a complete understanding of financial regulations, accounting standards, and localization best practices. We support translation and localization strategies that align with your goals.</div>
                    </div>
                    <div ref={section6Ref} role="section6-Images" className="financial-section6Images scrollbar-hide">
                        {section6Images?.map((item, idx) => (
                            <div key={idx} className="financial-section6ImageItem">
                                <CommonImage src={item?.src} alt={item?.alt} width={48} height={48} />
                                <div className="birth-imageBottomText">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section6Left}
                        scrollRight={section6Right}
                    />
                    <span className='sm:hidden block'>We’re the translation service provider that financial institutions and accounting firms trust to deliver consistent, high-quality work.</span>
                </div>
            </div>

            {/* Get Your Financial Documents Translated  with EVerbar */}
            <div className='financial-section7'>
                <div className='financial-section7Header'>
                    <div className='financial-section7Heading'>Certified Financial Document Translation You Can Trust</div>
                    <div className='financial-section7smallText'>We offer certified translation for documents used in regulatory filings, international reporting, and legal financial disclosures. Each certified translation is signed and includes a certificate of translation accuracy.</div>
                </div>
                <div className='financial-section7Card'>
                    If you need financial documents translated and certified for official use, we deliver fast, reliable translation backed by professional standards.
                </div>
            </div>


            {/* Translation Pricing for Financial Documents */}
            <div className='financial-section8-container bg-no-repeat bg-cover bg-center '>
                <div className='financial-section8'>
                    <div className='financial-section8Content'>
                        <span className='financial-section8ContentHeading'>Translation Pricing for Financial Documents</span>
                        <span className='financial-section8ContentCenterText'>We offer a $24.95 per page rate, with options for rush turnaround.  <span className="hidden md:inline"><br /><br /></span>You’ll receive upfront quotes with no hidden costs. Our pricing reflects the accuracy, confidentiality, and expert-level service you expect from the best financial translation services.</span>
                    </div>
                    <img className='financial-section8-desktopImg' src={require('../../assets/fin-sec8-img.png')} />
                    <div className='financial-section9-mobileImg md:hidden block'>
                        <CommonImage src={IMAGES.FIN_SEC8_MOBILEIMG} style={{
                            maxWidth: '100%',
                            display: 'block',
                            backgroundSize: 'contain'
                        }} />
                    </div>
                </div>
            </div>

            {/* FAQ */}
            <FAQ id='faqs-legal' faqData={financialDocumentTranslationData} />

            {/* Get Your Financial Documents Translated  with EVerbar */}
            <div className='financial-section10-container'>
                <div className='financial-section10'>
                    <div className='financial-section10Heading'>Get Your <span>Financial</span> Documents Translated with <span>eVerbary</span></div>
                    <div className='financial-section10smallText'>If you need financial document translation services, eVerbary is your professional translation agency. <br />We translate financial documents with care, accuracy, and speed.</div>
                </div>
            </div>

            {/* Footer */}
            <Footer windowSize={windowSize} />
        </TranslationPageLayout>
    )
}

export default FinancialDocumentTranslationPage